import { render, staticRenderFns } from "./ClientLogoUpload.vue?vue&type=template&id=1fff9f32&"
import script from "./ClientLogoUpload.vue?vue&type=script&lang=ts&"
export * from "./ClientLogoUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports